import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import NavArrow from "../../../assets/icon/NavArrow";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import { newsCard } from "../../../api/asyncThuncks/newsCards";
import { selectNews } from "../../../store/slices/news";
import NewsByCard from "./components/NewsByIdCard";
import EmptyContent from "../../../components/emptyContent/EmptyContent";

const loadingGif = require("../../../assets/loadingGif.gif") as string;

const NewsById = () => {
  const dispatch = useAppDispatch();
  const { newsById, loading, error } = useAppSelector(selectNews);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(newsCard(id))
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  }, [id, dispatch]);

  console.log(error, "newsId");

  const stripHtml = (html?: string) => {
    return html ? html.replace(/<[^>]*>/g, "").trim() : "";
  };

  const seoDescription = newsById
    ? newsById.metaDescription || stripHtml(newsById.description).slice(0, 150)
    : "";

  return (
    <>
      {newsById && newsById.title && (
        <Helmet>
          <title>{`Радіо «Сільпо» | ${newsById.title}`}</title>
          <meta name="title" content={`Радіо «Сільпо» | ${newsById.title}`} />
          <meta property="og:title" content={`Радіо «Сільпо» | ${newsById.title}`} />
          <meta name="twitter:title" content={`Радіо «Сільпо» | ${newsById.title}`} />

          <meta name="description" content={seoDescription} />
          <meta property="og:description" content={seoDescription} />
          <meta name="twitter:description" content={seoDescription} />

          {newsById.imagePath && (
            <>
              <meta property="og:image" content={newsById.imagePath} />
              <meta name="twitter:image" content={newsById.imagePath} />
            </>
          )}
        </Helmet>
      )}
      {loading === "pending" || (error && <EmptyContent />)}
      {loading !== "failed" && !error && (
        <div className="w-screen px-5 max-w-xl bg-white pt-9 md:max-w-[1000px] md:px-0">
          <div className="flex items-center text-sm text-[#5D6E97]">
            <Link className="pr-2" to="/">
              Головна
            </Link>
            <NavArrow />
            <Link className="px-2" to="/news">
              Новини
            </Link>
            <NavArrow />
            <div className="max-w-[13rem] text-ellipsis overflow-hidden whitespace-nowrap px-2 md:max-w-[35rem]">
              {newsById.title}
            </div>
          </div>

          {isLoading ? (
            <div className="w-full flex items-center justify-center pt-36">
              <img
                className="max-w-[50px] max-h-[50px]"
                src={loadingGif}
                alt="loading..."
              />
            </div>
          ) : (
            newsById && (
              <NewsByCard
                icon={newsById.imagePath}
                title={newsById.title}
                description={newsById.description}
                date={newsById.publishedAt}
                views={newsById.viewCounter}
                youtubeUrl={newsById.youtubeUrl}
              />
            )
          )}
        </div>
      )}
    </>
  );
};

export default NewsById;
